<template>
    <div class="prison-naming-system">
        <Row>
            <Col>
                <div class="core-title">产品概述</div>
            </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
            <Col span="10">
                <div class="core-text">
                    <p>
                        监狱系统中，狱警每天都要对所有监舍的犯人进行清点工作。传统的“指纹识别”、“指静脉识别”这些设备都需要购买、安装。而网络摄像机一般的监室都有了。应用监室中的网络摄像机（一般每个监室都有）完全可以做到“人脸识别点名”。从而大大减轻民警的工作。本套智慧点名系统可利用监舍中安装的摄像头，运用人工智能技术，自动快速完成所有监舍罪犯的点名工作，极大地提高狱警人员的工作效率，同时降低监狱管理风险。适用于监狱看守所、重要活动场所的安全保卫工作、集会、反恐、刑侦、高等教育学校的点名管理。
                    </p>
                </div>
            </Col>
            <Col span="8">
                <div class="core-img">
                    <img src="@/images/core/prison.png" alt="智慧监狱点名系统">
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">行业分析</div>
            </Col>
        </Row>
        <Row>
            <Col>
                <Row class="core-content">
                    <Col span="11">
                        <div class="core-weakness core-weakness-left">
                            <div class="text">
                                <h5 class="text-right">硬件设备不可控</h5>
                                <p>监舍摄像头方向都是固定，不可调节、变焦摄像头大部分是大角度向下倾斜，且高度较高。</p>
                            </div>
                            <div class="img">
                                <img src="@/images/core/prisonWeakness1.png" alt="智慧监狱点名系统">
                            </div>
                        </div>
                    </Col>
                    <Col span="11" offset="2">
                        <div class="core-weakness core-weakness-right">
                            <div class="img">
                                <img src="@/images/core/prisonWeakness2.png" alt="智慧监狱点名系统">
                            </div>
                            <div class="text">
                                <h5>光线条件差</h5>
                                <p>监舍摄像头基本都是安装在监舍门上方，对着窗户，遮光严重。</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row class="core-content">
                    <Col span="11">
                        <div class="core-weakness core-weakness-left">
                            <div class="text">
                                <h5 class="text-right">物理环境特殊</h5>
                                <p>监舍房间小，内有很多高低床，遮挡严重。</p>
                            </div>
                            <div class="img">
                                <img src="@/images/core/prisonWeakness3.png" alt="智慧监狱点名系统">
                            </div>
                        </div>
                    </Col>
                    <Col span="11" offset="2">
                        <div class="core-weakness core-weakness-right">
                            <div class="img">
                                <img src="@/images/core/prisonWeakness4.png" alt="智慧监狱点名系统">
                            </div>
                            <div class="text">
                                <h5>对象特征不明显</h5>
                                <p>罪犯统一条纹衣服着装，且都是光头。</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">功能简介</div>
            </Col>
        </Row>
        <Row class="core-content">
            <Col span="5">
                <div class="core-card">
                    <div class="core-card-title">
                        <img src="@/images/core/face.png" alt="智慧监狱点名系统">
                        <span>前端抓拍</span>
                    </div>
                    <div class="img">
                        <img src="@/images/core/arrowDown.png" alt="智慧监狱点名系统">
                    </div>
                    <div class="core-card-title">
                        <img src="@/images/core/naming.png" alt="智慧监狱点名系统">
                        <span>自动点名</span>
                    </div>
                    <div class="img">
                        <img src="@/images/core/arrowDown.png" alt="智慧监狱点名系统">
                    </div>
                    <div class="core-card-title">
                        <img src="@/images/core/dataError.png" alt="智慧监狱点名系统">
                        <span>异常告警</span>
                    </div>
                    <div class="img">
                        <img src="@/images/core/arrowDown.png" alt="智慧监狱点名系统">
                    </div>
                    <div class="core-card-title">
                        <img src="@/images/core/data.png" alt="智慧监狱点名系统">
                        <span>数据汇报</span>
                    </div>
                </div>
            </Col>
            <Col span="3">
                <img src="@/images/core/rightLine.png" alt="智慧监狱点名系统">
            </Col>
            <Col span="16">
                <div class="core-img">
                    <img src="@/images/core/prisonNamingSystem.png" alt="智慧监狱点名系统">
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">产品优势</div>
            </Col>
        </Row>
        <Row class="core-content">
            <Col span="11">
                <div class="core-advantage">
                    <div class="img">
                        <img src="@/images/core/prisonAdvantage1.png" alt="智慧监狱点名系统">
                        <div class="innerText">
                            精准识别
                        </div>
                    </div>
                    <div class="text">
                        本系统充分利用人工智能技术，在摄像头逆光、有严重遮挡物、角度高度均不理想情况下，做到100% 完成监舍点名任务，做到不漏报、不误报。
                    </div>
                </div>
            </Col>
            <Col span="11" offset="2">
                <div class="core-advantage">
                    <div class="img">
                        <img src="@/images/core/prisonAdvantage2.png" alt="智慧监狱点名系统">
                        <div class="innerText">
                            速度快
                        </div>
                    </div>
                    <div class="text">
                        点名速度快，每个监舍平均不超过2分钟就能完成点名，且各监舍可同时点名。
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">应用领域</div>
            </Col>
        </Row>
        <Row class="core-applications core-content">
            <Col span="8" offset="2">
                <div class="application">
                    <div class="title">
                        新疆某监狱
                    </div>
                    <div class="details">
                        本系统适用于所有监狱系统，劳教中心、看守所等监禁场所，为监狱系统提供便利，用更高效、更科技的方式进行现代化的智慧监狱打造。
                    </div>
                </div>
            </Col>
            <Col span="12" offset="2">
                <img src="@/images/core/coreApplication3.png" alt="视频实时分析系统">
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
  name: 'non-perceptual-security-system'
};
</script>

<style lang="less">
    .prison-naming-system {
        .core-img {
            height: 390px;
        }
    }
</style>
